import { render, staticRenderFns } from "./NewFieldDialog.vue?vue&type=template&id=f971aafa&scoped=true&"
import script from "./NewFieldDialog.vue?vue&type=script&lang=js&"
export * from "./NewFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewFieldDialog.vue?vue&type=style&index=0&id=f971aafa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f971aafa",
  null
  
)

export default component.exports